'use strict';

/**
 * @ngdoc filter
 * @name webAgro1App.filter:HumanizeFilter
 * @function
 * @description
 * # HumanizeFilter
 * Filter in the webAgro1App.
 */
angular.module('webAgro1App').filter('humanize', function() {
  return function(text) {
    if (text) {
      var string = text.split('_').join(' ').toLowerCase();
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  };
});
